import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from "environments";

@Injectable({
  providedIn: 'root'
})
export class StaffUsersService {
	private http = inject(HttpClient);

	private env = inject<PIMSEnvironment>(ENVIRONMENT)

	updateStaffUser(user_id:number, data:any) {
		return this.http.put(`${this.env.constants.ADMIN_API_URL}/admin/staffusers/${user_id}`, data)
	}

	getStaffUser(user_id:number) {
		return this.http.get(`${this.env.constants.ADMIN_API_URL}/admin/staffusers/${user_id}`)
	}

	addStaffUserLicense(user_id:number, stateCode: string, license_number:any) {
		return this.http.put(`${this.env.constants.ADMIN_API_URL}/admin/staffusers/${user_id}/licenses/${stateCode}`, {license_number})
	}

	removeStaffUser(user_id:number, stateCode: string) {
		return this.http.delete(`${this.env.constants.ADMIN_API_URL}/admin/staffusers/${user_id}/licenses/${stateCode}`)
	}

	uploadSignatureFile(user_id: number, formData: FormData) {
		return this.http.post(`${this.env.constants.ADMIN_API_URL}/admin/staffusers/${user_id}/signature`, formData);
	}

	uploadVideoFile(user_id: number, formData: FormData) {
		return this.http.post(`${this.env.constants.ADMIN_API_URL}/admin/staffusers/${user_id}/videos`, formData);
	}
}
